"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomString = randomString;
const crypto_1 = require("crypto");
function randomString(length = 32) {
    if (length % 2 !== 0) {
        length++;
    }
    return (0, crypto_1.randomBytes)(length / 2).toString("hex");
}
